<div class="tab-wrapper">
  <div class="row">
    <div class="col-lg-12">
      <div class="card" *ngIf="authService.canRead('employee_benefits_pto_panel')">
        <div class="card-body">
          <div class="float-end">
            <button
              cpGTagEvent
              [params]="{ event_label: 'people_edit_add_pto' }"
              appAutoFocus
              type="button"
              class="btn btn-primary"
              (click)="addPTO()"
              [disabled]="
                (readOnly | async) || (ptos | async).length == (ptoConfigs | async).length
              ">
              <i class="fas fa-xs fa-plus"></i>&nbsp;Add Time Off Plan
            </button>
          </div>
          <h4 class="card-title">Time Off Plans</h4>
          <table *ngIf="(ptos | async).length > 0" class="table">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th>Anniversary Date</th>
                <th class="text-end">Carry Over</th>
                <th class="text-end">Accrued</th>
                <th class="text-end">Used</th>
                <th class="text-end">Balance</th>
                <th style="width: 100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pto of ptos | async">
                <td>{{ (getPTOConfig(pto.Id) | async).Name }}</td>
                <td>
                  <span *ngIf="pto.IsActive" class="text-cp-green">Active</span>
                  <span *ngIf="!pto.IsActive" class="text-danger">Inactive</span>
                </td>
                <td>{{ pto.AnniversaryDate | date: 'MM/dd/YY' }}</td>
                <td class="text-end">{{ pto.CarryOver | number: '1.2-2' }}</td>
                <td class="text-end">{{ pto.AccruedHours | number: '1.2-2' }}</td>
                <td class="text-end">{{ pto.UsedHours | number: '1.2-2' }}</td>
                <td class="text-end">{{ pto.Balance | number: '1.2-2' }}</td>
                <td>
                  <a (click)="editPTO(pto)">View/Edit</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<lib-employee-pto-config
  *ngIf="showPtoModal"
  [readonly]="readOnly | async"
  [ptos]="ptos | async"
  [ptoConfigs]="ptoConfigs | async"
  [existingModel]="selPTO"
  [clientCode]="clientCode"
  [person]="person | async"
  (modalClosed)="modalClosed()"></lib-employee-pto-config>
